import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './glossary-build.component.scss';
import * as $ from 'jquery';
var GlossaryBuild = /** @class */ (function (_super) {
    tslib_1.__extends(GlossaryBuild, _super);
    function GlossaryBuild(element) {
        return _super.call(this, element) || this;
    }
    GlossaryBuild.prototype.init = function () {
        this.inputSearch = this.element.querySelector('.js-search-bar');
        this.alphabetContainer = this.element.querySelector('.js-alphabet-block');
        this.alphabetContainerMobile = this.element.querySelector('.js-alphabet-block-mobile');
        this.contentContainer = this.element.querySelector('.js-glossary-content');
        this.contentContainerEmpty = this.element.querySelector('.js-glossary-content-empty');
        this.contentContainerEmptyWording = this.element.querySelector('.js-glossary-content-empty-wording');
        this.buttonClear = this.element.querySelector('.glossary-build__form-field--searchbuttonclear');
        this.scrollTopOffset = this.element.getBoundingClientRect().y;
        if (jsonData) {
            this.json = jsonData;
            this.buildLayout(this.json);
        }
    };
    GlossaryBuild.prototype.bindEvents = function () {
        var _this = this;
        this.inputSearch.addEventListener('keydown', function (evt) {
            var value = _this.inputSearch.value;
            _this.buildLayout(_this.json, value);
        });
        this.inputSearch.addEventListener('keyup', function (evt) {
            var value = _this.inputSearch.value;
            _this.buildLayout(_this.json, value);
        });
        this.inputSearch.addEventListener('keypress', function (evt) {
            var value = _this.inputSearch.value;
            _this.buildLayout(_this.json, value);
        });
        window.addEventListener('scroll', function (event) {
            var windowOffset = window.pageYOffset;
            var getYOffset = $('div.glossary-build').offset();
            var alphabetAnchors = Array.from(_this.element.querySelectorAll('.js-alphabet-anchor'));
            alphabetAnchors.map(function (anchor) {
                var getAttributeLetter = anchor.getAttribute('data-letter');
                var letterOffset = anchor.offsetTop;
                var letterHeight = anchor.clientHeight;
                var spaceOffset = (getYOffset.top + letterOffset) - windowOffset;
                var spaceHeight = (getYOffset.top + letterOffset + letterHeight) - windowOffset;
                var getButton = _this.element.querySelector('a.js-alphabet-button[data-letter=' + getAttributeLetter + ']');
                var getButtonMobile = _this.element.querySelector('a.js-alphabet-button-mobile[data-letter=' + getAttributeLetter + ']');
                if (spaceOffset < 20 && spaceHeight > 0) {
                    getButton.classList.add('glossary-build__sticky--inner__jump--block__button--active');
                    getButtonMobile.classList.add('glossary-build__sticky--inner__jump--block__button--active');
                }
                else {
                    getButton.classList.remove('glossary-build__sticky--inner__jump--block__button--active');
                    getButtonMobile.classList.remove('glossary-build__sticky--inner__jump--block__button--active');
                }
            });
        });
        this.buttonClear.addEventListener('click', function (evt) {
            _this.inputSearch.value = '';
            var value = '';
            _this.buildLayout(_this.json, value);
        });
    };
    GlossaryBuild.prototype.buildLayout = function (array, value) {
        if (array === void 0) { array = []; }
        if (value === void 0) { value = ''; }
        if (!value) {
            this.buttonClear.classList.add('d-none');
        }
        else {
            this.buttonClear.classList.remove('d-none');
        }
        var input = value.toLowerCase();
        var arrayNew = [];
        var arrayOld = this.json;
        var empty = true;
        arrayOld.forEach(function (letter) {
            var letterObject = {};
            var letterArray = [];
            var letterItems = letter.items;
            var letterName = letter.name;
            letterItems.forEach(function (item) {
                var itemName = item.name.toLowerCase();
                if (itemName.includes(input)) {
                    letterArray.push(item);
                    empty = false;
                }
            });
            letterObject.name = letterName;
            letterObject.items = letterArray;
            arrayNew.push(letterObject);
        });
        if (empty) {
            this.contentContainerEmptyWording.innerHTML = value;
            this.contentContainerEmpty.classList.remove('d-none');
        }
        else {
            this.contentContainerEmpty.classList.add('d-none');
        }
        if (value) {
            this.buildContent(arrayNew, value);
            this.buildAlphabets(arrayNew);
        }
        else {
            this.buildContent(arrayOld, value);
            this.buildAlphabets(arrayOld);
        }
    };
    GlossaryBuild.prototype.buildContent = function (array, value) {
        if (array === void 0) { array = []; }
        if (value === void 0) { value = ''; }
        this.contentContainer.innerHTML = '';
        var output = "";
        array.forEach(function (letter) {
            if (letter.items.length > 0) {
                output += "<div class=\"glossary-build__letter js-alphabet-anchor\" data-letter=\"" + letter.name + "\">";
                output += "<div class=\"glossary-build__title title--number\">" + letter.name + "</div>";
                letter.items.forEach(function (item) {
                    if (value.length > 0) {
                        var name_1 = item.name;
                        var lowercaseName = name_1.toLowerCase();
                        var lowercaseValue = value.toLowerCase();
                        var starting = lowercaseName.indexOf(lowercaseValue);
                        var ending = starting + lowercaseValue.length;
                        var getOrigString = "<span class=\"glossary-build__highlight\">" + name_1.substring(starting, ending) + "</span>";
                        var getOrigStringBefore = name_1.substring(0, starting);
                        var getOrigStringAfter = name_1.substring(ending, name_1.length);
                        var newString = getOrigStringBefore + getOrigString + getOrigStringAfter;
                        output += "<div class=\"title title title--module-sub-title\">" + newString + "</div>";
                    }
                    else {
                        output += "<div class=\"title title title--module-sub-title\">" + item.name + "</div>";
                    }
                    output += "<div class=\"glossary-build__description\">" + item.description + "</div>";
                    output += "<div class=\"glossary-build__spacer\"></div>";
                });
                output += "</div>";
            }
        });
        var docFragment = document.createDocumentFragment();
        docFragment.appendChild(document.createRange().createContextualFragment(output));
        this.contentContainer.appendChild(docFragment);
    };
    GlossaryBuild.prototype.buildAlphabets = function (array) {
        var _this = this;
        if (array === void 0) { array = []; }
        var output = "";
        var index = 0;
        this.alphabetContainer.innerHTML = '';
        this.alphabetContainerMobile.innerHTML = '';
        var alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        alphabet.forEach(function (letter) {
            var enablement = false;
            array.forEach(function (item) {
                if (item.name === letter) {
                    if (item.items.length > 0) {
                        enablement = true;
                    }
                }
            });
            var btnLetter = document.createElement('a');
            var btnLetterMobile = document.createElement('a');
            btnLetter.innerText = letter;
            btnLetterMobile.innerText = letter;
            btnLetter.setAttribute('href', 'javascript:void(0)');
            btnLetterMobile.setAttribute('href', 'javascript:void(0)');
            btnLetter.setAttribute('data-letter', letter);
            btnLetterMobile.setAttribute('data-letter', letter);
            btnLetter.classList.add('glossary-build__sticky--inner__jump--block__button');
            btnLetterMobile.classList.add('glossary-build__sticky--inner__jump--block__button');
            btnLetter.classList.add('js-alphabet-button');
            btnLetterMobile.classList.add('js-alphabet-button-mobile');
            if (enablement) {
                index++;
                if (index === 1) {
                    btnLetter.classList.add('glossary-build__sticky--inner__jump--block__button--active');
                    btnLetterMobile.classList.add('glossary-build__sticky--inner__jump--block__button--active');
                }
                btnLetter.onclick = function (event) {
                    var element = undefined;
                    if (event.currentTarget) {
                        element = event.currentTarget;
                    }
                    else {
                        element = event.target;
                    }
                    var getLetter = element.getAttribute('data-letter');
                    var getAnchor = _this.element.querySelector('div.js-alphabet-anchor[data-letter=' + getLetter + ']');
                    var offset = _this.scrollTopOffset + getAnchor.offsetTop;
                    $('html, body').animate({
                        scrollTop: offset
                    }, 500);
                };
                btnLetterMobile.onclick = function (event) {
                    var element = undefined;
                    if (event.currentTarget) {
                        element = event.currentTarget;
                    }
                    else {
                        element = event.target;
                    }
                    var getLetter = element.getAttribute('data-letter');
                    var getAnchor = _this.element.querySelector('div.js-alphabet-anchor[data-letter=' + getLetter + ']');
                    var offset = _this.scrollTopOffset + getAnchor.offsetTop;
                    $('html, body').animate({
                        scrollTop: offset
                    }, 500);
                };
            }
            else {
                btnLetter.classList.add('glossary-build__sticky--inner__jump--block__button--inactive');
                btnLetterMobile.classList.add('glossary-build__sticky--inner__jump--block__button--inactive');
            }
            _this.alphabetContainer.appendChild(btnLetter);
            _this.alphabetContainerMobile.appendChild(btnLetterMobile);
        });
        var btnLBackToTop = document.createElement('a');
        btnLBackToTop.innerText = "BACK TO TOP";
        btnLBackToTop.setAttribute('href', 'javascript:void(0)');
        btnLBackToTop.classList.add('glossary-build__sticky--inner__jump--block__button');
        btnLBackToTop.classList.add('glossary-build__back-top');
        btnLBackToTop.onclick = function (event) {
            $('html, body').animate({
                scrollTop: _this.scrollTopOffset - 300
            }, 500);
        };
        this.alphabetContainer.appendChild(btnLBackToTop);
    };
    GlossaryBuild.prototype.replaceString = function (str, start, end, replace) {
        if (start < 0 || start > str.length) {
            throw new RangeError("start index " + start + " is out of the range 0~" + str.length);
        }
        if (end > str.length || end < start) {
            throw new RangeError("end index " + end + " is out of the range " + start + "~" + str.length);
        }
        return str.substring(0, start) + replace + str.substring(end);
    };
    return GlossaryBuild;
}(Base));
export { GlossaryBuild };



//////////////////
// WEBPACK FOOTER
// ./components/glossary-build/glossary-build.component.ts
// module id = 341
// module chunks = 0